import {useState, useEffect} from 'react';
import useTranslate from "../../../../utils/useTranslate"
import {
    BoatLifts
} from "../../../../data/products/BoatLift";
import {ProductsProps} from "../Products";
import {InfoCircle as BSIconInfoCircle} from "react-bootstrap-icons";
import Button from 'react-bootstrap/Button';
import ProductsPlus from "../ProductsPlus";

import './ProductBoatLift.scss';

export const ProductBoatLift = ({selectProductVariant, ...props}: ProductsProps) => {
    const[haveInfoForProduct, setHaveInfoForProduct] = useState<boolean>(false);
    const {t} = useTranslate();

    useEffect(() => {
        let h = (props.infoForProduct !== undefined);
        if (haveInfoForProduct !== h) {
            setHaveInfoForProduct(h);
        }
    }, [props, haveInfoForProduct]);

    return (
            <div className="ams-product-item-boat_lifts">
                {
                    BoatLifts.map((iBoatLift, iindex) => {
                        if (props.checkProduct !== undefined && !props.checkProduct(iBoatLift)) {
                            return (null);
                        }
                        let title = t(iBoatLift.title);
                        let info = t(iBoatLift.info);
                        return (
                            <div key={"ams-product-item-boat_lift-key-" + iindex}>
                                <div className="ams-product-item-boat_lift-title">
                                    <span>{title}</span>
                                    {
                                        haveInfoForProduct &&
                                        <BSIconInfoCircle onClick={() => {
                                            if (props.infoForProduct !== undefined) {
                                                props.infoForProduct(iBoatLift);
                                            }
                                        }} />
                                    }
                                </div>
                                {
                                    !haveInfoForProduct &&
                                    <div className="ams-product-item-boat_lift-info">
                                        <div dangerouslySetInnerHTML={{__html: info}}></div>
                                    </div>
                                }
                                <div className="ams-product-item-boat_lift-messures">{iBoatLift.width} x {iBoatLift.height} {t('mm')}</div>
                                <div className="ams-product-item-boat_lift-subs">
                                    {
                                        iBoatLift.variants.map((isBoatLift, isindex) => {
                                            if (props.checkProductVariant !== undefined && !props.checkProductVariant(iBoatLift, isBoatLift)) {
                                                return (null);
                                            }
                                            let stitle = t(isBoatLift.title);
                                            let shortInfo: string | null = isBoatLift.shortInfo ? t(isBoatLift.shortInfo) : null;
                                            return (
                                                <div key={"ams-product-item-boat_lift-key-" + iindex + "-" + isindex}
                                                        className="ams-product-item-boat_lift-sub">
                                                    <div onClick={() => {selectProductVariant(iBoatLift, isBoatLift);}}
                                                            className="ams-product-item-boat_lift-image">
                                                        <img src={isBoatLift.imageMenu} alt={title + " - " + stitle} title={title + " - " + stitle} />
                                                        {
                                                            !!stitle &&
                                                            <div className="ams-product-item-boat_lift-sub-title">{stitle}</div>
                                                        }
                                                        {
                                                            props.checkProduct === undefined && props.checkProductVariant === undefined &&
                                                            <ProductsPlus />
                                                        }
                                                    </div>
                                                    {
                                                        !!shortInfo &&
                                                        <div className="ams-product-item-boat_lift-sub-short-info">
                                                            <div dangerouslySetInnerHTML={{__html: shortInfo}}></div>
                                                            <div>
                                                                {
                                                                    haveInfoForProduct &&
                                                                    <Button variant="primary" onClick={() => {
                                                                            if (props.infoForProduct !== undefined) {
                                                                                props.infoForProduct(iBoatLift);
                                                                            }
                                                                        }}>
                                                                        {t('Details')}
                                                                    </Button>
                                                                }
                                                            </div>
                                                        </div>
                                                    }
                                                </div>
                                            );
                                        })
                                    }
                                </div>
                            </div>
                        );
                    })
                }
            </div>
            );
};

export default ProductBoatLift;
